<template>
  <v-container>
    <h1>Lag nytt produkt</h1>

    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-subheader>Detaljer</v-subheader>

          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="product.name"
                    label="Navn"
                    required
                    :disabled="isSaving"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="product.price"
                    label="Pris"
                    required
                    :disabled="isSaving"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="product.description"
                    label="Beskrivelse"
                    required
                    :disabled="isSaving"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="product.vat_class"
                    :items="vat_classes"
                    item-value="id"
                    label="Momsklasse"
                    single-line
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }} ({{ data.item.percentage }}%)
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }} ({{ data.item.percentage }}%)
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="success"
                    :loading="isSaving"
                    @click="saveProduct"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Lagre
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "AdminProductCreate",

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      vendor: {},
      product: {
        name: "",
        description: "",
        price: "",
        vat_class: "",
      },
      isSaving: false,
      vat_classes: [],
    };
  },

  async created() {
    this.vat_classes = await backend.get("vat/");
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
  },

  methods: {
    async saveProduct() {
      this.isSaving = true;
      this.product = await backend.post(
        "products/",
        {
          name: this.product.name,
          description: this.product.description,
          price: this.product.price,
          vendor: this.vendor.id,
          vat_class: this.product.vat_class,
        },
        {
          vendor: this.vendor.id,
        }
      );

      this.isSaving = false;

      this.$router.push({
        name: "adminProducts",
        params: {
          vendorId: this.vendorId,
        },
      });

      this.$store.dispatch("add", {
        type: "success",
        message: "Produktet er opprettet.",
      });
    },
  },
};
</script>
